import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AiTwotoneFileText }  from "react-icons/ai";
import { Form, Modal, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

/* import function from store folder */
import { resetModel } from '../../../store/components/modelSlice';

/* import fetch function */
import { ImportBusinessMember } from "../../../services/business";

const UploadModel = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const [accept, setAccept] =  useState('.csv');
    const [error, setError] = useState({});
    const [source, setSource] = useState({});

    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, files }}) => {
        const _source = Object.assign({}, source);
        
        delete error[name];
        _source[name] = files[0];

        setError(error);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {
            const forms = new FormData();

            forms.append('file', source.file);
            
            ImportBusinessMember(forms).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                }
            });
        }
    };

    const validate = values => {
        const checkLists = ['file'];
        const _errors = {};

        checkLists.map( list => {
            if (!source[list])
                _errors[list] = true;
        });
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    useEffect(() => { (pathname === '/survey') && setAccept('.xlsx') }, [])

    return (
        <Modal show={ true } centered>
            <Modal.Header>Import Member</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <Form.Control as='a' href='https://life-span-public-test.s3.us-east-2.amazonaws.com/test_import.csv'>
                            <AiTwotoneFileText />
                            <span className='text'>Download Sample File</span>
                        </Form.Control>
                    </div>
                    <div className="form-item">
                        <Form.Control type='file' name='file' accept={ accept } is-required={`${error.file}`} onChange={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="submit" data-shadow>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default UploadModel;